import { ShiftsPlanningVersionFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

export interface Props {
  id: string
  effective_at: string
  planning_tool: string
  default: boolean
  employee_id: string
}

class PlanningVersion {
  id: string
  effectiveAt: moment.Moment
  planningTool: string
  default: boolean
  employeeId: string

  constructor(props: Props) {
    this.id = props.id
    this.effectiveAt = stringToDate(props.effective_at, 'backend')
    this.planningTool = props.planning_tool
    this.default = props.default
    this.employeeId = props.employee_id
  }

  static buildFromGraphQL(fragment: ShiftsPlanningVersionFragment): PlanningVersion {
    return new PlanningVersion({
      id: fragment.id ?? '0',
      effective_at: fragment.effectiveAt,
      planning_tool: fragment.planningTool,
      default: false,
      employee_id: fragment.employeeId,
    })
  }

  static default(employeeId: string): PlanningVersion {
    return new PlanningVersion({
      id: '0',
      default: true,
      planning_tool: PLANNING_TOOL.contractHours,
      effective_at: '01/01/1970',
      employee_id: employeeId,
    })
  }

  get isContractHoursTool(): boolean {
    return this.planningTool === PLANNING_TOOL.contractHours
  }

  get isWorkScheduleTool(): boolean {
    return this.planningTool === PLANNING_TOOL.workSchedule
  }

  get isShiftManagementTool(): boolean {
    return this.planningTool === PLANNING_TOOL.shiftManagement
  }
}

export default PlanningVersion
